import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { forEach } from '@angular/router/src/utils/collection';
import { InactiveAutoTrainingCodeComponent } from '../training-management/inactive-auto-training-code/inactive-auto-training-code.component';
import { BaseComponent } from './../base/base.component';
import { ChckboxComponent, CheckboxState } from './../chckbox/chckbox.component';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent extends BaseComponent implements OnInit {


  @Input() table: Table[][];

  @Input() header: Array<Table>;

  @Input() isPaginator = false;

  @Output() buttonClicked: EventEmitter<object> = new EventEmitter();

  @Output() linkClicked: EventEmitter<object> = new EventEmitter();

  @Input() tableLength = 0;

  @Output() checkboxClicked: EventEmitter<Array<number>> = new EventEmitter();

  @ViewChildren('checkBox') private checkBox;

  @ViewChild('headerCheckBox') headerCheckbox: ChckboxComponent;

  private isAllChecked = false;

  pageNumber = 0;

  selectedRows: Array<number>;

  constructor(ele: ElementRef) {
    super(ele);
    this.selectedRows = [];
  }

  ngOnInit() { }

  onClick(type: Types, id: number, title: string , identifier: number, row, colIndex: number) {
    if (type === 1 || type === 16)
    {
      this.buttonClicked.emit({ tableRow: row, buttonClickedTitle: title, toIdentify: identifier, index: id, colIndex });
    }
  }
  getCheckboxes() {
    return this.checkBox.toArray();
  }

  onCheckBoxClicked(event, index) {
    const allCheckBoxes = this.checkBox.toArray();
    if (event.checkboxState === CheckboxState.CHECKED) {
      if (index === -1) {
        this.checkAll(true, allCheckBoxes);
      } else {
        if (this.isAllCBManuallyChecked(allCheckBoxes) && this.headerCheckbox) {
          this.headerCheckbox.isSelected = true;
        }
        this.selectedRows.push(index);
      }
    } else if (event.checkboxState === CheckboxState.UNCHECKED) {
      if (index === -1) {
        this.checkAll(false, allCheckBoxes);
      } else {
        if (this.isAllChecked && this.headerCheckbox) {
          this.headerCheckbox.isSelected = false;
        }
        this.selectedRows.splice(this.selectedRows.indexOf(index), 1);
      }
    }
    this.checkboxClicked.emit(this.selectedRows.sort());
  }

  onLinkClicked(id: number) {
    this.linkClicked.emit(this.table[id]);
  }

  onPageChange(pageNumber) {
    this.pageNumber = pageNumber;
  }

  isAllCBManuallyChecked(allCheckBoxes): boolean {
    let checkCount = 0;
    for (let i = 0; i < allCheckBoxes.length; i++) {
      if (allCheckBoxes[i].isSelected) {
        ++checkCount;
      }
    }
    if (checkCount === allCheckBoxes.length) {
      this.isAllChecked = true;
      return true;
    }
    return false;
  }

  checkAll(boolVal, allCheckBoxes) {
    this.selectedRows = [];
    allCheckBoxes.forEach((checkbox) => {
      if (checkbox.isEnable) {
        checkbox.isSelected = boolVal;
      }
    });
    for (let i = 0; i < this.table.length; i++) {
      if (boolVal) {
        this.selectedRows.push(i);
      } else {
        this.selectedRows.splice(this.selectedRows.indexOf(i), 1);
      }

    }
    this.isAllChecked = boolVal;
  }
}

export class Table {
  type: Types;
  strClass: string;
  title: string | number;
  labelDetails: string;
  strClassCsv: string = null;
  strClassExcel: string = null;
  strClassPdf: string = null;
  strClassDownloadingExcel: string = null;
  strClassDownloadingPdf: string = null;
  cellOptions: Array<CompletionCellData>;
  skillId: string;

  constructor(types: Types, strClass: string, title: string | number, labelDetails?: string,  iconClass?: any,
    skillId?: string, cellOptions?: Map<string, CompletionCellData>) {
    this.type = types;
    this.strClass = strClass;
    this.title = title;
    this.labelDetails = labelDetails;
    this.skillId = skillId;
    this.cellOptions = this.sortMapByKey(cellOptions);

    if ( iconClass ) {
      this.strClassCsv = iconClass.csvLogo ? iconClass.csvLogo : null;
      this.strClassExcel = iconClass.excelLogo ? iconClass.excelLogo : null;
      this.strClassPdf = iconClass.pdfLogo ? iconClass.pdfLogo : null;
      this.strClassDownloadingExcel = iconClass.excelDownloadingLogo ? iconClass.excelDownloadingLogo : null;
      this.strClassDownloadingPdf = iconClass.pdfDownloadingLogo ? iconClass.pdfDownloadingLogo : null;
    }
  }

  sortMapByKey(map: Map<string, CompletionCellData>): Array<CompletionCellData> {
    if (map) {
      const keys = ['word', 'excel', 'powerpoint', 'access', 'outlook'];
      const retMap: Array<CompletionCellData> = new Array();
      for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (map.has(key)) {
          retMap.push(map.get(key));
        }
      }
      return retMap;
    }
    return null;
  }
}

export interface CompletionCellData {
  strClass: string;
  totalTasks: number;
  completedTasks: number;
}

export enum Types {
  TEXT = 0,
  BUTTON = 1,
  INT = 2,
  DATE = 3,
  LINK = 4,
  CHECK_BOX = 5,
  HIDDEN_ID = 6,
  POPUP = 7,
  HIGHLIGHT_ROW = 8,
  MAIL_TO = 9,
  LINK_IMGLINk_IMGLINK = 12,
  LINK_ICON = 10,
  IMG_TEXT = 11,
  MINMAX_LIST = 13,
  IMGLINK_IMGLINK = 14,
  BUTTON_AC_DEAC = 16,
  COMPLETION_PROGRESS = 17
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/table/table.component.ts